const pagesize = 10; //列表页面统一10条每页

/**
 * 作者：刘冰清
 * 针对起望框架fisher.xml文件的列表查询
 * @param empty {function} 如果本次查询为空时返回
 * @param success {function} 如果查询有值时返回
 * @param error {function} 如果查询失败时返回
 * 说明：
 */
const request = options => {
    var me = this;
    var defaults = {
        isDebug: false,
        tempData: undefined, //临时数据
        listDataKeyName: 'list', //数据结构中存放真实列表数据集合的属性名
        appendAttributes: [], //对象数组，支持给列表的每一项追加属性,{key:"",value:""},value非必填，默认为""

        url: '', //列表的请求URL
        context: undefined, //上下文，一定要是vue的this
        waitingtip: '加载中…', //遮罩层的提示语
        //默认未登录时也能加载列表,注:如果使用权限必须在调用时设为true
        needLogin: true, //是否带自动携带logintoken
        isShowLoading: true,
        pager: undefined, //【必值】,pager对象
        headers: {},
        ajaxOpt: {
            //ajax的参数配置
            dataType: 'json', //传输数据的数据类型
            type: 'GET' //HTTP请求类型
            //timeout: 10000 //列表查询不设置超时时间，在后台统一控制
        },
        // data: {
        //     //请求的数据源
        //     page: '1' //页码数，默认会把pager.pagenum的值赋值给page
        // },
        urlQueryParmas: {},
        success: function(data, opt, parameters, hasMore) {
            data = opt.prepareRender(data);

            opt.pager.rows = [];
            opt.pager.total = data.data.total - 0;
            for (let i = 0; i < data.data[opt.listDataKeyName].length; i++) {
                let item = data.data[opt.listDataKeyName][i];
                for (let j = 0; j < opt.appendAttributes.length; j++) {
                    item[opt.appendAttributes[j].key] = opt.appendAttributes[j].value || '';
                }
                opt.pager.rows.push(item);
            }
            if (hasMore) {
                opt.pager.status = 'more';
            } else {
                opt.pager.status = 'noMore';
            }
            // console.log('fisherResuest-defaultSuccess:查询时返回成功!');
            if (pager.rows.length == 0) {
                opt.empty();
            }

            opt.afterRender(data, opt, parameters, hasMore);
        },
        /**
         * 【可重写】如果本次请求为空时，则会调用该方法
         */
        empty: function() {
            console.log('default empty......');
        },
        /**
         * 【可重写】ajax响应的数据在渲染之前需要进行的数据处理
         * 	例如需要对原返回的值进行处理时
         * 	注：未重写success的有效
         * @param {Object} data
         */
        prepareRender: function(data) {
            // console.log('prepareRender invork......');
            return data;
        },
        //【可重写】处理完成后的回调
        afterRender: function(data, opt, parameters, hasMore) {
            // console.log('afterRender invork......');
        }
    };

    //let _ajaxOpt = options.ajaxOpt;

    let opt = {...defaults, ...options};
    let pager = opt.pager;
    let pageData = opt.data;
    //将pager.pagenum的值塞给pageData.page,因为fisher的查询需要这样
    if (pager) {
        pageData.page = pager.pagenum;
        pageData.pagesize = pager.pagesize;
    } else {
        pager = {};
    }

    let url = opt.url;
    url = opt.context.$basicRequest.appendUrlParameter(url, opt.urlQueryParmas);

    // console.log("开始向服务器请求数据，请求地址：" + url);
    // console.log("当前加载第【" + pager.pagenum + "】页的数据。");
    // console.log("请求参数" + JSON.stringify(pageData));
    // console.log("ajax的配置参数：" + JSON.stringify(opt.ajaxOpt));

    if (opt.isDebug) {
        opt.success(opt.tempData, opt, {}, true);
        return;
    }
    opt.context.$basicRequest.request({
        context: opt.context,
        url: url,
        ajaxOpt: opt.ajaxOpt,
        data: pageData,
        headers: opt.headers,
        isShowLoading: opt.isShowLoading,
        needLogin: opt.needLogin,
        waitingtip: opt.waitingtip,
        success: function(data, _parameters) {
            let hasMore = true;
            //pageCount 最大页数
            if (data.total / data.pagesize <= data.page) {
                hasMore = false;
            }
            opt.success(data, opt, _parameters, hasMore);
        },
        error: function(error, message, _parameters) {
            defaultError(error, message, opt);
        }
    });
};
/**
 * 去除<span></span>双标签类型的html标签
 * @param {Object} data
 */
const removeHtmlLabel = function(data) {
    var str = '';
    if (data != undefined && data != null && data != '') {
        if (data.indexOf('>') >= 0) {
            var temp1 = data.split('>');
            var temp2 = temp1[1].split('<');
            str = temp2[0];
        } else {
            str = data;
        }
    }
    return str;
};
const defaultSuccess = (data, message, parameters, hasMore) => {
    let pager = parameters.pager;
    if (parameters.success) {
        parameters.success(data, message, parameters, hasMore);
        return;
    }
    for (let i = 0; i < data.content.rows.length; i++) {
        pager.rows.push(data.content.rows[i]);
    }
    if (data.content.rows.length > 0) {
        pager.pagenum += 1;
    }
    if (hasMore) {
        pager.status = 'more';
    } else {
        pager.status = 'noMore';
    }
    // console.log('fisherResuest-defaultSuccess:查询时返回成功!');
    if (pager.rows.length == 0) {
        parameters.empty();
    }
};
const defaultError = (data, message, parameters) => {
    console.error('fisherResuest###执行异常,请求参数>>>>>>>>:' + JSON.stringify(parameters.data));
    if (parameters.error != null && typeof parameters.error == 'function') {
        console.error('fisherResuest###开始回调自定义error');
        try {
            parameters.error(data, message, parameters);
        } catch (err) {
            console.error('fisherResuest###回调自定义error异常:' + JSON.stringify(err));
        }
    }
    parameters.context.$message.error('程序执行异常，请与管理员联络!\n' + message);
    console.error('fisherResuest-defaultError-over!');
};

export default {request, removeHtmlLabel, pagesize};
